import { useStyletron } from 'baseui';

const useStyles = () => {
	const [css] = useStyletron();

	const styledHeaderContainer = css({
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		minWidth: '500px'
	});

	const styledHeaderTitle = css({
		fontWeight: 'bold',
		padding: '12px 0px'
	});

	const styledDownloadButtonContainer = css({
		padding: '6px 0px'
	});

	const downloadButtonOverrides = {
		BaseButton: {
			style: { backgroundColor: '#000000', color: '#fff', borderRadius: '4px' }
		}
	};

	return {
		styledHeaderContainer,
		styledHeaderTitle,
		styledDownloadButtonContainer,
		downloadButtonOverrides
	};
};

export default useStyles;
